import React, { useEffect, useState } from 'react';
import {
  Container,
  Flex,
  Heading,
  Section,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@grubhubprod/gh-cookbook-react';
import { useHistory, useLocation } from 'react-router-dom';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import {
  ISelfServiceTealiumPageView,
  useAnalytics,
} from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import { useGetQueryParams } from 'src/utilities/useGetQueryParams';
import GroupLanding from './Groups/GroupLanding';
import PeopleLanding from './PeopleLanding';

enum TabIndex {
  PEOPLE = 0,
  GROUPS = 1,
}

const gaPageEventByTab: Record<TabIndex, ISelfServiceTealiumPageView> = {
  [TabIndex.PEOPLE]: {
    pageGroup: 'corporate self service - account management',
    pageName: 'People Details',
  },
  [TabIndex.GROUPS]: {
    pageGroup: 'corporate self service - account management',
    pageName: 'Grubhub | Self-Service Account | People | Group List',
    subGroup: 'People Details > Group List',
  },
};

export default function PeopleLandingPage(): JSX.Element {
  const { sendTealiumPageView } = useAnalytics();
  const { sendAnalytics } = useSendAnalytics({
    eventcategory: 'self-service management tool_people',
    eventaction: 'groups tab_cta',
    eventlabel: 'groups tab on people page',
  });
  const { search } = useLocation();
  const { replace } = useHistory();
  const tab = useGetQueryParams('tab');

  const { isPhone } = useScreenSizes();

  const defaultTabIndex = tab === 'groups' ? TabIndex.GROUPS : TabIndex.PEOPLE;

  const [currentTabIndex, setCurrentTabIndex] =
    useState<TabIndex>(defaultTabIndex);

  useEffect(() => {
    if (tab) {
      const newSearchParams = new URLSearchParams(search);
      newSearchParams.delete('tab');

      replace({ search: newSearchParams.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, tab]);

  useEffect(() => {
    sendTealiumPageView(gaPageEventByTab[currentTabIndex]);

    if (currentTabIndex === TabIndex.GROUPS) {
      sendAnalytics();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex]);

  return (
    <Container variant="default">
      <Section inset="md">
        <Stack y="sm">
          <Flex
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            <Flex flexBasis={isPhone ? '100%' : '50%'}>
              <Heading variant="h1">People</Heading>
            </Flex>
          </Flex>
        </Stack>
        <Tabs defaultIndex={defaultTabIndex} onChange={setCurrentTabIndex}>
          <Stack y="sm">
            <TabList>
              <Tab as="button">All people</Tab>
              <Tab as="button">Groups</Tab>
            </TabList>
          </Stack>
          <TabPanels>
            <TabPanel>
              <PeopleLanding />
            </TabPanel>
            <TabPanel>
              <GroupLanding />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Section>
    </Container>
  );
}
